import { Button, ButtonProps } from '@mui/material';
import { useStyles } from 'tss-react/mui';
import { IS_UXBEAUTY } from 'components/constants/Constants';

type SearchHeaderButtonProps = {
  Icon: React.ComponentType;
  active: boolean;
  variant: string;
} & ButtonProps;

export const SearchHeaderButton: React.FC<
  React.PropsWithChildren<SearchHeaderButtonProps>
> = ({ Icon, className, active, children, variant, ...props }) => {
  const { cx } = useStyles();
  return (
    <Button
      {...props}
      className={cx(className, { active: active })}
      variant={variant}
      size="small"
      startIcon={!IS_UXBEAUTY ? <Icon /> : null}
    >
      &nbsp;
      {children}
    </Button>
  );
};
